import { Link } from 'gatsby';
import React from 'react'
import * as styles from './direct-download.module.scss';
import { FiExternalLink } from 'react-icons/fi'

const DirectDownload = ({ data }) => {
    const {
        title,
        downloadableFile
    } = data
    return (
        <div>
            <div className={`blog-body ${styles.downloadContainer}`}>
                {/* <a href={downloadableFile?.file?.url} target="_blank"><span> <FiExternalLink /> </span>{title}</a> */}
                <a href={downloadableFile?.file?.url} target="_blank">{title}</a>
            </div>
        </div>
    )
}

export default DirectDownload